import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getLanguageCodes = () => {
  return dispatch => {
    dispatch({ type: "GET_LANGUAGE_CODES_LOADING" });
    api
      .languageCodesGet()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        //dispatch({ type: "GET_LANGUAGE_CODES_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_LANGUAGE_CODES_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetLanguageCodesErrorAlertTitle",
          "Virhe kielitaitojen haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_LANGUAGE_CODES_SUCCEEDED",
  payload: { languageCodes: data },
});

const operationFail = () => ({
  type: "GET_LANGUAGE_CODES_FAIL",
});
